(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8582],{

/***/ 58582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero030": function() { return /* binding */ Hero030; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14258);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52853);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32667);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87367);
/* harmony import */ var _Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6677);
/* harmony import */ var _Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9__);










var Hero030 = function(param) {
    var payload = param.payload;
    var ref;
    var headline = (ref = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var subtitle = (ref1 = payload === null || payload === void 0 ? void 0 : payload.subtitle) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var description = (ref2 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var image = (ref3 = payload === null || payload === void 0 ? void 0 : payload.image) !== null && ref3 !== void 0 ? ref3 : {};
    var ref4;
    var ref5 = (ref4 = payload === null || payload === void 0 ? void 0 : payload.attachment) !== null && ref4 !== void 0 ? ref4 : {}, attachmentButtonText = ref5.attachmentButtonText, file = ref5.file;
    var ref6;
    var ref7 = (ref6 = payload === null || payload === void 0 ? void 0 : payload.request) !== null && ref6 !== void 0 ? ref6 : {}, buttonText = ref7.buttonText, form = ref7.form, type = ref7.type, link = ref7.link;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().query;
    var ref8 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useToggle */ .OT)(), opened = ref8.opened, onOpen = ref8.onOpen, onClose = ref8.onClose;
    var baseUrl =  true ? window.location.origin : 0;
    var externalLink = (link === null || link === void 0 ? void 0 : link.startsWith("http")) || (link === null || link === void 0 ? void 0 : link.startsWith("https")) ? link : "".concat(baseUrl).concat(link);
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_3__/* .buildWidgetInstanceId */ .G1)("030", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__/* .WIDGETS_REGISTRY.HERO */ .R.HERO);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().top),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Heading2 */ .XJ, {
                            className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().headline),
                            color: "dark",
                            children: headline
                        }),
                        type === "external link" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href: externalLink,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().play),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().arrow),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                        className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
                                        name: "arrow_right"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                    color: "brand",
                                    appearance: "bigger",
                                    children: buttonText
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Action */ .aU, {
                            onClick: onOpen,
                            className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().play),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().arrow),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                        className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
                                        name: "arrow_right"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                    color: "brand",
                                    appearance: "bigger",
                                    children: buttonText
                                })
                            ]
                        }),
                        opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ModalWrapper */ .AB, {
                            onCloseModal: onClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                item: form,
                                metaData: {
                                    page: query.slug
                                },
                                instanceId: instanceId,
                                onReset: onClose
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().left),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Heading6 */ .Cd, {
                                    className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().subtitle),
                                    color: "dark",
                                    children: subtitle
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .RenderIf */ .$b, {
                                    viewMode: shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_7__/* .VIEW_MODES.MOBILE */ .nY.MOBILE,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                                        className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().description),
                                        value: description,
                                        color: "dark"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().file),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .DownloadFile */ .xn, {
                                        file: file,
                                        label: attachmentButtonText
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .RenderIf */ .$b, {
                            viewMode: shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_7__/* .VIEW_MODES.DESKTOP */ .nY.DESKTOP,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().right),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                                    className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().description),
                                    value: description,
                                    color: "dark"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ImageLite */ .NH, {
                    image: image,
                    className: (_Hero030_module_scss__WEBPACK_IMPORTED_MODULE_9___default().image)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero030);


/***/ }),

/***/ 6677:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero030_wrapper__1zXTF","top":"Hero030_top__IudpZ","content":"Hero030_content__dH4NR","left":"Hero030_left__B2Bwa","right":"Hero030_right__wE6AV","headline":"Hero030_headline__Cu1YU","description":"Hero030_description__bui4o","image":"Hero030_image__Z7lP2","play":"Hero030_play__uRNRp","icon":"Hero030_icon__r9vqJ","arrow":"Hero030_arrow__kUWFN","subtitle":"Hero030_subtitle__I_vhv"};

/***/ })

}]);